import ArtworkLoupe from "components/ArtworkLoupe"
import TokenImage from "components/TokenImage"
import TokenLive from "components/TokenLive"

interface Props {
  contractAddress: string
  tokenId: string
  width: number
  chainId?: number
  invocation?: BigInt
  aspectRatio?: number
  live?: boolean
  showInvocationLink?: boolean
  maxHeight?: number
  generatorUrl?: string
  tokenHash?: string
  imageUrl?: string
  isStatic?: boolean
  alt?: string
  loupe?: boolean
  loupeZoom?: number
}

const TokenView = ({
  contractAddress,
  tokenId,
  width,
  chainId,
  invocation,
  aspectRatio = 1,
  live = false,
  showInvocationLink = true,
  maxHeight,
  generatorUrl,
  tokenHash,
  imageUrl,
  isStatic = false,
  alt,
  loupe = false,
  loupeZoom = 3,
}: Props) => {
  const safeAspectRatio = Number.isFinite(aspectRatio) && aspectRatio > 0 ? aspectRatio : 1
  const safeMaxHeight = maxHeight && maxHeight > 0 ? maxHeight : Number.POSITIVE_INFINITY
  let artWidth = Math.max(1, width)
  let artHeight = artWidth / safeAspectRatio

  if (artHeight > safeMaxHeight) {
    artHeight = safeMaxHeight
    artWidth = artHeight * safeAspectRatio
  }

  const shouldRenderLive = live && !isStatic
  const renderTokenContent = (contentWidth: number, contentHeight: number, isLoupe: boolean) => {
    // Keep a single live iframe on the base layer. A 3× loupe TokenLive would
    // spin a second HiDPI generator loop (MOS canvas ≈ dim × dpr × zoom).
    if (shouldRenderLive && !isLoupe) {
      return (
        <TokenLive
          contractAddress={contractAddress}
          tokenId={tokenId}
          width={contentWidth}
          height={contentHeight}
          chainId={chainId}
          generatorUrl={generatorUrl}
          tokenHash={tokenHash}
          imageUrl={imageUrl}
          inert={loupe}
        />
      )
    }

    return (
      <TokenImage
        contractAddress={contractAddress}
        tokenId={tokenId}
        width={contentWidth}
        height={contentHeight}
        chainId={chainId}
        imageUrl={imageUrl}
        alt={isLoupe ? "" : alt}
      />
    )
  }

  return (
    <figure className="m-0" style={{ width: artWidth }}>
      <ArtworkLoupe
        active={loupe}
        width={artWidth}
        height={artHeight}
        zoom={loupeZoom}
        renderContent={renderTokenContent}
      />
      {invocation !== undefined && showInvocationLink && (
        <div className="flex justify-end mt-1">
          <a
            href={`/token/${contractAddress}/${tokenId}`}
            className="gallery-label gallery-link text-gallery-muted hover:text-gallery-text"
          >
            No. {invocation?.toString()}
          </a>
        </div>
      )}
    </figure>
  )
}

export default TokenView
